export const UPDATE_TASK_TITLE = "UPDATE_TASK_TITLE"
export const UPDATE_ASSIGN_BY = "UPDATE_ASSIGN_BY"
export const UPDATE_ASSIGNED = "UPDATE_ASSIGNED"
export const UPDATE_TASK_DUE_DATE = "UPDATE_TASK_DUE_DATE"
export const UPDATE_TASK_DESCRIPTION = "UPDATE_TASK_DESCRIPTION"
export const SAVE_TASK = "SAVE_TASK"
export const FETCH_TASKS = "FETCH_TASKS"
export const RECEIVE_TASKS = "RECEIVE_TASKS"
export const DELETE_TASKS = "DELETE_TASKS"
export const TOGGLE_TASK_DRAWER_EDIT = "TOGGLE_TASK_DRAWER_EDIT"
export const EDIT_TASK = "EDIT_TASK"
export const UPDATE_TASK_ID = "UPDATE_TASK_ID"
export const UPDATE_TASK_STATUS = "UPDATE_TASK_STATUS"
export const UPDATE_TASK_ERROR = "UPDATE_TASK_ERROR"

export const updateTaskDescription = (taskDescription) => ({
  type: UPDATE_TASK_DESCRIPTION,
  taskDescription,
})

export const fetchTasks = (success, error) => ({
  type: FETCH_TASKS,
  success,
  error,
})

export const updateTaskStatus = (taskStatus) => ({
  type: UPDATE_TASK_STATUS,
  taskStatus,
})

export const receiveTasks = (tasks) => ({
  type: RECEIVE_TASKS,
  tasks,
})

export const deleteTasks = (taskIds, success, error) => ({
  type: DELETE_TASKS,
  taskIds,
  success,
  error,
})

export const updateTaskDueDate = (taskDueDate) => ({
  type: UPDATE_TASK_DUE_DATE,
  taskDueDate,
})

export const toggleTaskDrawerEdit = () => ({
  type: TOGGLE_TASK_DRAWER_EDIT,
})

export const updateAssigned = (assigned) => ({
  type: UPDATE_ASSIGNED,
  assigned,
})

export const updateAssignBy = (assignBy) => ({
  type: UPDATE_ASSIGN_BY,
  assignBy,
})

export const updateTaskTitle = (taskTitle) => ({
  type: UPDATE_TASK_TITLE,
  taskTitle,
})

export const updateTaskId = (taskId) => ({
  type: UPDATE_TASK_ID,
  taskId,
})

export const saveTask = (success, error) => ({
  type: SAVE_TASK,
  success,
  error,
})

export const updateTaskError = (errorMessage) => ({
  type: UPDATE_TASK_ERROR,
  errorMessage,
})

export const editTask = (success, error) => ({
  type: EDIT_TASK,
  success,
  error,
})
